import Vue from 'vue';
import Router from 'vue-router';
import HomeView from '@/views/Home';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js